/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkedAccounts
 */
export interface LinkedAccounts {
    /**
     * 
     * @type {string}
     * @memberof LinkedAccounts
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkedAccounts
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkedAccounts
     */
    confirmPassword?: string;
}

/**
 * Check if a given object implements the LinkedAccounts interface.
 */
export function instanceOfLinkedAccounts(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LinkedAccountsFromJSON(json: any): LinkedAccounts {
    return LinkedAccountsFromJSONTyped(json, false);
}

export function LinkedAccountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkedAccounts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'confirmPassword': !exists(json, 'confirmPassword') ? undefined : json['confirmPassword'],
    };
}

export function LinkedAccountsToJSON(value?: LinkedAccounts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
        'confirmPassword': value.confirmPassword,
    };
}

